<ng-container *ngIf="services.isDesktop()">
    <div class='welcome-intro'>
        <div class="welcome-set">
            <div class="welcome-intro-profile" [ngClass]="{'start-animate': doStartAnimation}">
                <img id="userImage" [src]="userImageUri" />
            </div>
            <div class="welcome-user-txt" [ngClass]="{'start-animate-txt': doStartAnimation}">
                <h1>{{helloTxt | translate}}<br><span>{{username}}</span></h1>
            </div>
        </div>

        <div dir="ltr" class="intro-wave">
            <div class="intro-wave-holder">
                <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin meet"
                    viewBox="0 0 2610.987 727.791">
                    <g id="Wires" transform="matrix(0.999, -0.035, 0.035, 0.999, -220.254, -8.315)">
                        <path id="Path_10139" data-name="Path 10139"
                            d="M2806.9,542.366c-170.342-93.4-1008.605-467.8-1628.028-139.077C692.25,661.539,495.124-62.808,211.959,246.341"
                            transform="translate(0 84.304)" fill="none" stroke="#00a10bB0" stroke-miterlimit="10"
                            stroke-width="1" />
                        <path id="Path_10140" data-name="Path 10140"
                            d="M2806.542,514.784c-192.11-85.8-992.839-418.384-1608.43-120.934C712.289,628.6,497.573-52.331,212.217,254.653"
                            transform="translate(0.355 91.894)" fill="none" stroke="#459839" stroke-miterlimit="10"
                            stroke-width="1" />
                        <path id="Path_10141" data-name="Path 10141"
                            d="M2806.186,487.375c-213.875-78.192-977.2-369.058-1588.833-102.788C732.223,595.786,500.024-41.68,212.476,263.14"
                            transform="translate(0.712 99.309)" fill="none" stroke="#47993a" stroke-miterlimit="10"
                            stroke-width="1" />
                        <path id="Path_10142" data-name="Path 10142"
                            d="M2805.83,460.169c-235.637-70.587-961.684-319.842-1569.239-84.641C752.054,563.1,502.474-30.825,212.734,271.83"
                            transform="translate(1.067 106.521)" fill="none" stroke="#4a9b3a" stroke-miterlimit="10"
                            stroke-width="1" />
                        <path id="Path_10143" data-name="Path 10143"
                            d="M2805.474,433.2c-257.4-62.981-946.293-270.76-1549.65-66.5-484.04,163.871-750.9-386.438-1042.831-85.948"
                            transform="translate(1.423 113.495)" fill="none" stroke="#4c9d3b" stroke-miterlimit="10"
                            stroke-width="1" />
                        <path id="Path_10144" data-name="Path 10144"
                            d="M2805.119,406.515c-279.152-55.377-931.021-221.833-1530.062-48.35C791.418,498.227,507.373-8.358,213.251,289.97"
                            transform="translate(1.778 120.187)" fill="none" stroke="#4e9e3b" stroke-miterlimit="10"
                            stroke-width="1" />
                        <path id="Path_10145" data-name="Path 10145"
                            d="M2804.762,380.163c-300.9-47.773-915.858-173.079-1510.476-30.2C810.958,466.092,509.822,3.352,213.51,299.515"
                            transform="translate(2.135 126.545)" fill="none" stroke="#50a03c" stroke-miterlimit="10"
                            stroke-width="1" />
                        <path id="Path_10146" data-name="Path 10146"
                            d="M2804.406,354.215c-322.654-40.171-900.8-124.522-1490.894-12.062C830.413,434.222,512.27,15.462,213.769,309.46"
                            transform="translate(2.491 132.501)" fill="none" stroke="#53a23c" stroke-miterlimit="10"
                            stroke-width="1" />
                        <path id="Path_10147" data-name="Path 10147"
                            d="M2804.051,328.747c-344.4-32.567-885.828-76.172-1471.314,6.083C849.791,402.677,514.718,28.055,214.027,319.888"
                            transform="translate(2.846 137.976)" fill="none" stroke="#55a43c" stroke-miterlimit="10"
                            stroke-width="1" />
                        <path id="Path_10148" data-name="Path 10148"
                            d="M2803.695,303.862C2437.55,278.9,1932.757,275.817,1351.958,328.09,869.1,371.55,517.166,41.231,214.286,330.9"
                            transform="translate(3.203 142.866)" fill="none" stroke="#57a53d" stroke-miterlimit="10"
                            stroke-width="1" />
                        <path id="Path_10149" data-name="Path 10149"
                            d="M2803.34,279.684c-387.885-17.356-856.109,19.842-1432.164,42.374C888.362,340.945,519.614,55.114,214.544,342.617"
                            transform="translate(3.558 147.05)" fill="none" stroke="#59a73d" stroke-miterlimit="10"
                            stroke-width="1" />
                        <path id="Path_10150" data-name="Path 10150"
                            d="M2802.983,256.358c-409.622-9.752-841.326,67.482-1412.591,60.519C907.579,310.994,522.062,69.849,214.8,355.188"
                            transform="translate(3.914 150.382)" fill="none" stroke="#5ca93e" stroke-miterlimit="10"
                            stroke-width="1" />
                        <path id="Path_10151" data-name="Path 10151"
                            d="M2802.628,234.046c-431.356-2.151-826.57,114.867-1393.022,78.662-482.834-30.858-885.1-227.113-1194.545,56.061"
                            transform="translate(4.269 152.703)" fill="none" stroke="#5eaa3e" stroke-miterlimit="10"
                            stroke-width="1" />
                        <path id="Path_10152" data-name="Path 10152"
                            d="M2802.271,216.217c-453.086,5.454-811.823,162-1373.456,96.81-482.857-56.049-901.86-207.2-1213.495,73.81"
                            transform="translate(4.626 150.537)" fill="none" stroke="#60ac3e" stroke-miterlimit="10"
                            stroke-width="1" />
                        <path id="Path_10153" data-name="Path 10153"
                            d="M2801.915,207.8c-474.815,13.058-797.067,208.88-1353.893,114.955C965.148,241.3,529.4,135.474,215.579,414.318"
                            transform="translate(4.982 138.957)" fill="none" stroke="#62ae3f" stroke-miterlimit="10"
                            stroke-width="1" />
                        <path id="Path_10154" data-name="Path 10154"
                            d="M2801.56,199.389c-496.539,20.664-782.282,255.517-1334.332,133.1C984.365,225.416,531.848,165.121,215.837,441.8"
                            transform="translate(5.337 127.377)" fill="none" stroke="#64af3f" stroke-miterlimit="10"
                            stroke-width="1" />
                        <path id="Path_10155" data-name="Path 10155"
                            d="M2801.2,190.975c-518.261,28.268-767.45,301.914-1314.775,151.245C1003.622,209.313,534.292,194.768,216.1,469.283"
                            transform="translate(5.694 115.797)" fill="none" stroke="#67b140" stroke-miterlimit="10"
                            stroke-width="1" />
                        <path id="Path_10156" data-name="Path 10156"
                            d="M2800.849,182.561c-539.98,35.872-752.553,348.089-1295.22,169.391C1022.936,193,536.738,224.414,216.354,496.765"
                            transform="translate(6.049 104.217)" fill="none" stroke="#69b340" stroke-miterlimit="10"
                            stroke-width="1" />
                        <path id="Path_10157" data-name="Path 10157"
                            d="M2800.492,174.148C2238.8,217.622,2062.916,568.2,1524.825,361.682,1042.32,176.493,539.183,254.062,216.613,524.245"
                            transform="translate(6.405 92.639)" fill="none" stroke="#6bb441" stroke-miterlimit="10"
                            stroke-width="1" />
                        <path id="Path_10158" data-name="Path 10158"
                            d="M2800.136,165.734c-583.407,51.078-722.506,439.838-1256.118,205.679C1061.789,159.8,541.628,283.709,216.872,551.73"
                            transform="translate(6.762 81.059)" fill="none" stroke="#6db641" stroke-miterlimit="10"
                            stroke-width="1" />
                        <path id="Path_10159" data-name="Path 10159"
                            d="M2799.78,157.32C2194.665,216,2092.45,642.773,1563.209,381.144,1081.354,142.941,544.072,313.356,217.13,579.212"
                            transform="translate(7.117 69.479)" fill="none" stroke="#70b841" stroke-miterlimit="10"
                            stroke-width="1" />
                        <path id="Path_10160" data-name="Path 10160"
                            d="M2799.424,148.906C2172.6,215.195,2107.385,679.831,1582.4,390.875,1101.022,125.927,546.516,343,217.389,606.694"
                            transform="translate(7.473 57.899)" fill="none" stroke="#72ba42" stroke-miterlimit="10"
                            stroke-width="1" />
                        <path id="Path_10161" data-name="Path 10161"
                            d="M2799.069,140.492c-648.525,73.893-676.627,576.274-1197.485,260.117C1120.8,108.778,548.961,372.65,217.647,634.176"
                            transform="translate(7.828 46.319)" fill="none" stroke="#74bb42" stroke-miterlimit="10"
                            stroke-width="1" />
                        <path id="Path_10162" data-name="Path 10162"
                            d="M2798.712,132.079c-670.224,81.494-661.087,621.521-1177.947,278.26C1140.7,91.514,551.4,402.3,217.906,661.657"
                            transform="translate(8.185 34.74)" fill="none" stroke="#76bd43" stroke-miterlimit="10"
                            stroke-width="1" />
                        <path id="Path_10163" data-name="Path 10163"
                            d="M2798.357,123.665c-691.921,89.1-645.418,666.694-1158.411,296.405C1160.721,74.155,553.846,431.942,218.164,689.139"
                            transform="translate(8.54 23.16)" fill="none" stroke="#79bf43" stroke-miterlimit="10"
                            stroke-width="1" />
                        <path id="Path_10164" data-name="Path 10164"
                            d="M2798,115.251c-713.614,96.7-629.618,711.812-1138.877,314.551C1180.861,56.721,556.289,461.589,218.423,716.621"
                            transform="translate(8.896 11.58)" fill="none" stroke="#7bc044" stroke-miterlimit="10"
                            stroke-width="1" />
                        <path id="Path_10165" data-name="Path 10165"
                            d="M2797.645,106.837c-735.3,104.309-613.689,756.9-1119.349,332.7C1201.122,39.227,558.732,491.236,218.682,744.1"
                            transform="translate(9.253 0)" fill="none" stroke="#7dc244" stroke-miterlimit="10"
                            stroke-width="1" />
                    </g>
                </svg>
            </div>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="services.isMobile()">
    <div [ngClass]="!greenifyEnabledUSer ?  'welcome-intro' : '' ">

        <ng-container>
            <div class="intro-wave" dir="ltr"><img src="./assets/images/login-wave.svg" /></div>
            <div class="welcome-set">
                <div class="welcome-intro-profile" [ngClass]="{'start-animate': doStartAnimation}">
                    <img id="userImage" [src]="userImageUri" />
                </div>
                <div class="welcome-user-txt" [ngClass]="{'start-animate-txt': doStartAnimation}">
                    <h1>{{helloTxt | translate}}<br><span>{{username}}</span></h1>
                </div>
            </div>
        </ng-container>
        
    </div>
</ng-container>